import React, { useEffect, useState } from "react";
import { Grid, TextField, Icon } from "@mui/material";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";

import Container from "../Container";
import MDTypography from "../MDTypography";

const PassGate = ({ children, pass, gate, title }) => {
  const [isValid, setIsValid] = useState(false);
  const cookies = new Cookies();

  useEffect(() => {
    setIsValid(false);
    const cookie = cookies.get(gate, { path: "/" });

    if (!pass || cookie) {
      setIsValid(true);
    }
  }, [gate, pass]);

  const handlePasswordChange = (e) => {
    const enteredPassword = e.target.value;

    if (enteredPassword === pass) {
      setIsValid(true);
      cookies.set(gate, true, {
        path: "/",
        expires: new Date(Date.now() + 31541845719), // ~1 year
      });
    }
  };

  if (isValid) return children;

  return (
    <Container>
      <MDTypography variant="h5">{title}</MDTypography>
      <Grid item xs={12} sx={{ textAlign: "center", mt: 6 }}>
        <Icon fontSize="large" sx={{ mr: 1, pt: "3px" }}>lock</Icon>
        <TextField
          label="Password"
          type="password"
          onChange={handlePasswordChange}
          autoComplete="new-password"
        />
      </Grid>
    </Container>
  );
};

PassGate.propTypes = {
  children: PropTypes.node,
  pass: PropTypes.string,
  gate: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default PassGate;
